let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iNZ4I")).then(() => parcelRequire('gRkfD'));